export const StepType = {
    podcast: "podcast",
    video: "video",
    multitrack: "multitrack"
}

export function isValidStepType(stepType){
    console.log("stepType", stepType);
    if(!stepType){
        return false;
    }

    return StepType.hasOwnProperty(stepType.toLowerCase());
}
